<template>
    <div>
        <el-upload
            class="files-to-upload"
            :disabled="onlyReadAlias"
            :action="uploadUrl"
            :headers="{'Authorization':api_token}"
            :file-list="fileList"
            :show-file-list="false"
            accept=".png, .jpg, .jpeg"
            :before-upload="beforeUpload"
            :on-progress="onProgress"
            :on-success="uploadedFile"
            :on-error="onError">
            <el-button
                :disabled="disabledButton"
                size="small"
                type="primary"
                v-text="buttonText">
            </el-button>
        </el-upload>
        <br>
        <el-row>
            <el-col :span="8" :key="0" :offset="0">
                <el-card :body-style="{ padding: '0px' }">
                    <img :src="photoUrl" class="image">
                    <div style="padding: 14px;">
                        <span>Imagen actual</span>
                        <div class="bottom clearfix">
                            <el-button type="text" class="button" @click="deleteElement()">Eliminar</el-button>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>

    </div>
</template>
<script>
    export default {
        mounted(){
            this.uploadUrl = '/api/save-file/'+this.type;
            this.api_token = 'Bearer ' +  window.sessionStorage.getItem('sipac_token');
            this.lastHeader();
        },
        props: {
            buttonName: {},
            fileId: {
            },
            view: {
                type: Boolean
            },
            type:{
                type:Number,
                required:true
            },
            model:{
                type:Object
            },
            onlyRead:{

            },
            isLawyer:{},


        },

        data() {
            return {
                fileList: [],
                uploadUrl:"",
                api_token:"",
                photoUrl: null,
                disabledButton: false
            };
        },
        computed: {

            onlyReadAlias(){
                return this.onlyRead ?  this.onlyRead:false;
            },
            alias_view(){
                return this.fileId && this.view === true ? true : false;
            },
            buttonText:{
                get:function(){
                    const DEFAULT_BUTTON_TEXT = "Clic para subir archivo";
                    if(!this.buttonName){
                        return DEFAULT_BUTTON_TEXT;
                    }
                    return this.buttonName
                }
            }
        },
        methods: {

            lastHeader(){
                axios.get('/api/papers/get-last-element/'+this.type, {responseType: 'blob'})
                    .then(response => {
                        let _type = response.data.type.toString();
                        if(_type == 'application/json'){
                            this.disabledButton = false;
                            this.$store.dispatch('notifications/info', {msg: 'Uno o más elementos no se han configurado.'}, {root: true});
                        }else if(_type.includes('image')){
                            let blob = new Blob([response.data], {type: response.data.type});
                            this.photoUrl = URL.createObjectURL(blob);
                            this.disabledButton = true;
                        }

                    })
                    .catch(error => {
                        this.$store.dispatch('notifications/error', {msg: 'No se pudo generar.'}, {root: true});
                        console.log("error", error);
                    });
            },

            beforeUpload(file) {
                let _this = this;
                let isImage = false;
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (file.type === 'image/jpeg' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/x-png' ||
                    file.type === 'image/png') {
                    isImage = true;
                }
                if(isImage===false){
                    this.$message.error('Sólo se permiten documentos en formato imagen');
                }

                if (!isLt2M) {
                    this.$message.error('Los archivos de documentos no pueden exceder los 2MB');
                }
                if(isImage && isLt2M){
                    _this.$store.dispatch('loading/spinner', { msg: 'Subiendo archivo...', status: true }, { root: true });
                }

                return isImage && isLt2M;
            },
            uploadedFile(data){
                if(data && data.message){
                    this.$store.dispatch('notifications/error', {msg: data.message}, {root: true});
                }else{

                    this.lastHeader();
                }

            },
            onError(err, file, fileList){
                console.log(err);
            },
            onProgress(event, file, fileList){
                let _this = this;
                if(event.percent==100){
                    setTimeout(() => {
                        _this.$store.dispatch('loading/spinner', {}, { root: true });
                    }, 500);
                }
            },

            deleteElement(){
                axios.post('/api/papers/delete-element',{type: this.type}).then(response => {
                    if(response.data.success){
                        this.disabledButton = false;
                        this.photoUrl = null;
                    }else{
                        this.$store.dispatch('notifications/info', {msg: response.data.message}, {root: true});
                    }

                })
            },
        }
    };
</script>


<style scoped>
    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }
</style>
